import { ConnectedApps } from "@WahooFitness/cloud-client-ts";
import { useCloudContext, useConfigContext, useOfflineSWR } from "@WahooFitness/wahoo-offline-mfe";
import { useCallback, useMemo } from "react";
import useSWR from "swr";

const useConnectedApps = (useOfflineCache = false) => {
  const { getCloudClient } = useCloudContext();
  const { wahooToken } = useConfigContext();
  const connectedAppsClient = useMemo(() => getCloudClient(ConnectedApps), [getCloudClient]);

  const key = useMemo(() => ["connectedApps", wahooToken], [wahooToken]);

  const {
    data: connectedAppsData,
    isLoading: connectedAppsLoading,
    error: connectedAppsError,
    mutate: mutateConnectedApps,
  } = useSWR(useOfflineCache ? null : key, ([_key, token]) => connectedAppsClient.get(token));

  const {
    data: connectedAppsDataOffline,
    isLoading: connectedAppsLoadingOffline,
    error: connectedAppsErrorOffline,
    mutate: mutateConnectedAppsOffline,
  } = useOfflineSWR(useOfflineCache ? key : null, ([_key, token]) =>
    connectedAppsClient.get(token)
  );

  const refreshConnectedApp = useCallback(
    (appId: number) => connectedAppsClient.refreshConnectedApp(wahooToken, appId),
    [connectedAppsClient, wahooToken]
  );

  return {
    connectedAppsData: useOfflineCache ? connectedAppsDataOffline : connectedAppsData,
    connectedAppsLoading: useOfflineCache ? connectedAppsLoadingOffline : connectedAppsLoading,
    connectedAppsError: useOfflineCache ? connectedAppsErrorOffline : connectedAppsError,
    mutateConnectedApps: useOfflineCache ? mutateConnectedAppsOffline : mutateConnectedApps,
    refreshConnectedApp,
  };
};

export default useConnectedApps;
